<template>
  <CockpitDialog
    class="fixed top-200px left-500px w-800px h-600px"
    v-if="visible"
    :title="title + '安全风险等级管控清单'"
    @close="close"
  >
    <div class="w-full h-full">
      <div class="w-full h-full relative z-9999">
        <div class="flex mb-20px mr-10px">
          <el-input
            size="small"
            class="mr-10px !w-50"
            placeholder="请输入关键字"
            v-model="equipSearchData.keywords"
            clearable
          ></el-input>
          <el-select
            v-model="equipSearchData.riskPointType"
            size="small"
            class="mr-10px !w-50"
            placeholder="风险点类型"
            clearable
            popper-class="safety_select-popper"
            @change="changeValues"
          >
            <el-option
              v-for="item in identifyTypeList"
              :key="item.code"
              :label="item.displayName"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-select
            v-model="equipSearchData.controlLevel"
            size="small"
            class="mr-10px !w-50"
            placeholder="请选择风险级别"
            popper-class="safety_select-popper"
            clearable
          >
            <el-option
              v-for="item in resultList"
              :key="item.code"
              :label="item.displayName"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-select
            v-model="equipSearchData.ownedUnitId"
            size="small"
            class="mr-10px !w-50"
            placeholder="请选择责任单位"
            popper-class="safety_select-popper"
            filterable
            clearable
          >
            <el-option
              v-for="item in flatArr"
              :key="item.id"
              :label="item.displayName"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-button
            class="round-button"
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="handleSearch('equip')"
          ></el-button>
        </div>
        <el-table
          :data="equipDataList"
          class="w-full"
          :height="tableHeight"
          v-loading="equipTableLoading"
        >
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column
            label="风险点名称"
            prop="riskPointName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="风险点类型"
            width="120"
            prop="riskPointType"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="风险级别"
            width="120"
            prop="controlLevel"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="管控级别"
            width="80"
            prop="controlHierarchyText"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="责任单位"
            width="80"
            prop="organizationUnitName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="责任人"
            width="80"
            prop="leaderName"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="equipTableSizeChange"
          @current-change="equipTableCurrentChange"
          :current-page.sync="equipPageConfig.SkipCount"
          :page-size.sync="equipPageConfig.MaxResultCount"
          layout="prev, pager, next"
          :total="equipTotalCount"
          class="flex justify-center mt-20px ml-10px"
        ></el-pagination>
      </div>
    </div>
  </CockpitDialog>
</template>

<script>
import { HiddenRisksSmartScreenApi } from '@wiz-api/double-prevention-management'
import { OrganizationApi } from '@wiz-api/abp-identity'
import CockpitDialog from '../../../../../components/cockpit/CockpitDialog'

const organizationApi = new OrganizationApi()
const hiddenRisksSmartScreenApi = new HiddenRisksSmartScreenApi()

export default {
  name: 'safe-control-list',
  components: {
    CockpitDialog,
  },
  props: {
    areaId: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      flatArr: [],
      visible: true,
      areaList: [],
      selectionEquipData: [],
      resultList: [
        {
          code: 0,
          displayName: '重大风险',
        },
        {
          code: 1,
          displayName: '较大风险',
        },
        {
          code: 2,
          displayName: '一般风险',
        },
        {
          code: 3,
          displayName: '低风险',
        },
      ],
      identifyTypeList: [
        {
          code: 0,
          displayName: '设备设施',
        },
        {
          code: 1,
          displayName: '作业活动',
        },
      ],
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      equipSearchData: {
        keywords: '',
        ownedUnitId: '',
        areaId: this.areaId,
        evaluationLevel: '',
        riskPointType: 0,
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
  },
  mounted() {
    this.getEquipList()
    this.getOrgList()
  },
  methods: {
    // 切换查询
    changeValues(values) {
      this.handleSearch()
    },
    // 关闭弹窗
    close() {
      this.$emit('cancel')
    },
    // 搜索 equip 设备设施 job 作业活动
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      this.selectionEquipData = []
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...this.equipSearchData,
      }
      this.equipTableLoading = true
      const [err, res] = await hiddenRisksSmartScreenApi.securityRiskLevelControlPagedListQuery(
        data
      )
      if (!err) {
        this.equipDataList = res.items
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
    // 获取组织机构列表
    async getOrgList() {
      const [err, res] = await organizationApi.getAllListDetails({
        Filter: '',
        Sorting: '',
      })
      if (!err) {
        this.filterArr(res.items, this.flatArr)
      }
    },
    // 将部门数组扁平化
    filterArr(value, arr) {
      if (value.length > 0) {
        _.map(value, (it, index) => {
          arr.push(it)
          if (it.children && it.children.length > 0) {
            _.map(it.children, (items, num) => {
              arr.push(items)
              if (items.children && items.children.length > 0) {
                this.filterArr(items.children, arr)
              }
            })
          }
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '../../../assets/styles/filterSelect.scss';
</style>
<style scoped lang="scss">
@import '../../../assets/styles/input.scss';
@import '../../../assets/styles/table.scss';
@import '../../../assets/styles/pagination.scss';
@import '../../../assets/styles/shadow.scss';
@import '../../../assets/styles/button.scss';
@import '../../../assets/styles/dialog.scss';
@import '../../../assets/styles/loading.scss';

::v-deep .round-button {
  line-height: 1;
}
::v-deep .el-button {
  background-image: var(--cockpitButtonBg) !important;
}
::v-deep .el-input__inner {
  border: none;
}
</style>
